(() => {
  "use strict";

  const STORAGE_KEY = "shadowbox-commission-inquiry-key";

  function createKey() {
    if (window.crypto && typeof window.crypto.randomUUID === "function") return window.crypto.randomUUID();
    return `shadowbox-${Date.now()}-${Math.random().toString(36).slice(2)}`;
  }

  function init(formRoot) {
    const form = formRoot.querySelector("form");
    if (!form) return;
    const status = formRoot.querySelector("[data-status]");
    const verificationStatus = formRoot.querySelector("[data-verification-status]");
    const submit = formRoot.querySelector("[type=submit]");
    const tokenField = form.elements.namedItem("turnstile_token");
    const keyField = form.elements.namedItem("idempotency_key");
    const category = form.elements.namedItem("tcg_category");
    const customCategory = formRoot.querySelector("[data-custom-category]");
    const endpoint = formRoot.dataset.endpoint;
    const siteKey = formRoot.dataset.siteKey;
    let widgetId = null;

    const setStatus = (message, state = "error") => {
      status.textContent = message;
      status.dataset.state = state;
    };
    const setVerificationStatus = (message, state = "pending") => {
      verificationStatus.textContent = message;
      verificationStatus.dataset.state = state;
    };
    const getKey = () => {
      try {
        const saved = window.sessionStorage.getItem(STORAGE_KEY);
        if (saved) return saved;
        const key = createKey();
        window.sessionStorage.setItem(STORAGE_KEY, key);
        return key;
      } catch (_) {
        return createKey();
      }
    };
    keyField.value = getKey();
    submit.disabled = true;

    category.addEventListener("change", () => {
      const show = category.value === "other";
      customCategory.hidden = !show;
      const input = customCategory.querySelector("input");
      input.required = show;
      if (!show) input.value = "";
    });

    const resetTurnstile = (message = "Complete the security check to continue.") => {
      tokenField.value = "";
      submit.disabled = true;
      setVerificationStatus(message, "error");
      if (widgetId !== null && window.turnstile) window.turnstile.reset(widgetId);
    };
    const renderTurnstile = () => {
      if (!siteKey) {
        setVerificationStatus("Security verification is not configured yet.", "error");
        return;
      }
      if (!window.turnstile || widgetId !== null) return;
      widgetId = window.turnstile.render(formRoot.querySelector("[data-turnstile]"), {
        sitekey: siteKey,
        callback: token => {
          tokenField.value = token;
          submit.disabled = false;
          setVerificationStatus("Security check complete.", "success");
          setStatus("");
        },
        "expired-callback": () => resetTurnstile("The security check expired. Please complete it again."),
        "error-callback": () => resetTurnstile("The security check could not be completed. Please try again."),
      });
      setVerificationStatus("Complete the security check to continue.", "pending");
    };
    if (siteKey) {
      const timer = window.setInterval(() => {
        renderTurnstile();
        if (widgetId !== null) window.clearInterval(timer);
      }, 100);
      window.setTimeout(() => {
        window.clearInterval(timer);
        if (widgetId === null) setVerificationStatus("The security check is taking too long. Please refresh and try again.", "error");
      }, 10000);
    } else {
      renderTurnstile();
    }

    form.addEventListener("submit", async event => {
      event.preventDefault();
      if (!form.reportValidity()) return;
      if (!tokenField.value) {
        setStatus("Please complete the security check before sending.");
        return;
      }
      if (!endpoint) {
        setStatus("The inquiry form is not configured.");
        return;
      }
      submit.disabled = true;
      setStatus("Sending your inquiry…", "pending");
      const payload = {};
      new FormData(form).forEach((value, key) => {
        if (key !== "cf-turnstile-response") payload[key] = String(value);
      });
      try {
        const result = await fetch(endpoint, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          credentials: "omit",
          body: JSON.stringify(payload),
        });
        const body = await result.json().catch(() => ({}));
        if (!result.ok || body.success !== true) {
          setStatus(typeof body.error === "string" ? body.error : "I couldn’t send your inquiry. Please try again.");
          if (result.status === 400 || result.status === 503) resetTurnstile();
          else submit.disabled = false;
          return;
        }
        form.reset();
        tokenField.value = "";
        keyField.value = createKey();
        try { window.sessionStorage.setItem(STORAGE_KEY, keyField.value); } catch (_) { /* storage optional */ }
        customCategory.hidden = true;
        setVerificationStatus("Complete the security check to send another inquiry.", "pending");
        setStatus("Thank you — I’ve received your inquiry and will be in touch.", "success");
        if (widgetId !== null && window.turnstile) window.turnstile.reset(widgetId);
        submit.disabled = true;
      } catch (_) {
        setStatus("I couldn’t reach the inquiry service. Please try again.");
        submit.disabled = false;
      }
    });
  }

  document.querySelectorAll("[data-sbx-inquiry-form]").forEach(init);
})();
